import { useCallback } from "react";

import { useLeagueNaming } from "@/contexts";
import { BasesHavingAll, MessageKey } from "@/i18n";
import { LeagueNaming } from "@/types/league.types";

export const useAddLeagueNamingKey = () => {
  const naming = useLeagueNaming();

  const addLeagueNamingKey = useCallback(
    <TMessageKey extends BasesHavingAll<MessageKey, LeagueNaming>>(
      messageKey: TMessageKey
    ): `${TMessageKey}.${LeagueNaming}` => {
      return `${messageKey}.${naming}`;
    },
    [naming]
  );

  return addLeagueNamingKey;
};
